/* ============================================================
   Product Extras — Mark Ryden Wholesale
   Positions volume pricing table + Customize & Quote button
   on product pages, mirroring Backper store layout.
   ============================================================ */

(function () {
  'use strict';

  // Only run on product pages
  if (!document.body.classList.contains('template-product')) return;

  // ---- Position Volume Pricing Table ----
  function placeVolumeTable() {
    var src = document.getElementById('bls-vol-table-src');
    if (!src) return;

    // Try common price container selectors (Blum / Dawn / generic)
    var priceTarget = (
      document.querySelector('.product__price') ||
      document.querySelector('[class*="product__price"]') ||
      document.querySelector('.price--large') ||
      document.querySelector('.price__container') ||
      document.querySelector('.product-info .price') ||
      document.querySelector('[data-product-price]')
    );

    if (priceTarget) {
      // Insert volume table immediately after the price block
      var wrapper = priceTarget.closest('.product__price, .price__container, .product__price-wrapper') || priceTarget;
      wrapper.insertAdjacentElement('afterend', src);
      src.style.display = '';
    } else {
      // Fallback: show it hidden but visible (will appear at bottom of page)
      src.style.display = '';
    }
  }

  // ---- Add Customize & Quote Button ----
  function placeCustomizeButton() {
    // Don't add twice
    if (document.querySelector('.bls-cq-trigger-btn')) return;

    // Find the add-to-cart form / button area
    var formEl = (
      document.querySelector('form[action="/cart/add"]') ||
      document.querySelector('.product-form') ||
      document.querySelector('.product-form__buttons')
    );

    if (!formEl) return;

    var productTitle = (
      (document.querySelector('.product__title, .product-detail__name, h1.product__name') || {}).textContent ||
      document.title
    ).trim();

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.setAttribute('data-open', 'customize-quote');
    btn.setAttribute('data-product', productTitle);
    btn.className = 'bls-btn bls-cq-trigger-btn';
    btn.innerHTML =
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="flex-shrink:0">' +
        '<path d="M12 20h9"/>' +
        '<path d="M16.5 3.5a2.121 2.121 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/>' +
      '</svg>' +
      'CUSTOMIZE &amp; REQUEST QUOTE';

    btn.style.cssText = [
      'display:flex',
      'align-items:center',
      'justify-content:center',
      'gap:8px',
      'width:100%',
      'margin-top:10px',
      'padding:14px 20px',
      'font-size:15px',
      'font-weight:800',
      'letter-spacing:0.5px',
      'border:2px solid #1a1a1a',
      'border-radius:6px',
      'background:transparent',
      'color:#1a1a1a',
      'cursor:pointer',
      'transition:all 0.2s',
      'white-space:nowrap',
      'text-transform:uppercase',
    ].join(';');

    btn.addEventListener('mouseenter', function () {
      btn.style.background = '#1a1a1a';
      btn.style.color = '#fff';
    });
    btn.addEventListener('mouseleave', function () {
      btn.style.background = 'transparent';
      btn.style.color = '#1a1a1a';
    });

    // Insert after the form
    formEl.insertAdjacentElement('afterend', btn);
  }

  // ---- Run ----
  function init() {
    placeVolumeTable();
    placeCustomizeButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
